var _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRawMaterials = function SvgRawMaterials(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 38.1,
    height: 37.5,
    style: {
      overflow: "visible"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3 12.1c-.9 0-1.7-.3-2.5-.7.4.7.7 1.6.7 2.5s-.3 1.7-.7 2.5c.7-.4 1.6-.7 2.5-.7s1.7.3 2.5.7c-.4-.7-.7-1.6-.7-2.5s.3-1.7.7-2.5c-.7.5-1.6.7-2.5.7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m31.4 16.9 1.7 8.6-3.3 6.6-19.1-14 3.4-13.7 15.5 3.4.4 2.2.4.2c.2.1.5.3.7.4L30.5 7 13.6 3.3l-9.3 9.4L.6 29.4 10 37h14.8l5.7-3.8 3.8-7.5-1.8-8.9c-.4 0-.8 0-1.1.1zM5.2 13.1l7.7-7.7-3.2 12.8L1.9 28zM24.5 36H10.3L2 29.3 10.1 19l19 13.9z",
    style: {
      stroke: "#656565",
      strokeMiterlimit: 10
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3 4.9c-.1.4-.3.7-.6 1s-.7.5-1 .6c.4.1.7.3 1 .6s.5.7.6 1c.1-.4.3-.7.6-1s.7-.5 1-.6c-.4-.1-.7-.3-1-.6-.3-.2-.5-.6-.6-1M27.3 10.9c-.3-.3-.5-.7-.6-1-.1.4-.3.7-.6 1s-.7.5-1 .6c.4.1.7.3 1 .6s.5.7.6 1c.1-.4.3-.7.6-1s.7-.5 1-.6c-.4-.1-.7-.3-1-.6M26.7 15.2c-.6 0-1.1-.2-1.6-.4.3.5.4 1 .4 1.6s-.2 1.1-.4 1.6c.5-.3 1-.4 1.6-.4s1.1.2 1.6.4c-.3-.5-.4-1-.4-1.6s.2-1.1.4-1.6c-.5.2-1 .4-1.6.4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.4,
    cy: 0.8,
    r: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.3,
    cy: 20.4,
    r: 0.8
  })));
};
export { SvgRawMaterials as ReactComponent };
export default __webpack_public_path__ + "26a1dfc60a93b5f2385af199f10cbb43.svg";